/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'yurstrap';

import infoIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--info.svg';
import successIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--success.svg';
import warningIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--warning.svg';
import errorIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--error.svg';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
};

const defaultProps = {
    ...commonDefaultProps,
    type: 'info',
};

const MessageBoxIcon = (props) => {
    const classNames = [
        'c-msg-box__icon',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    let imageSrc = null;
    switch (props.type) {
        case 'success':
            imageSrc = successIcon;
            break;
        case 'warning':
            imageSrc = warningIcon;
            break;
        case 'error':
            imageSrc = errorIcon;
            break;
        default:
            imageSrc = infoIcon;
    }
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <Image src={imageSrc} />
        </props.componentClass>
    );
};

MessageBoxIcon.propTypes = propTypes;

MessageBoxIcon.defaultProps = defaultProps;

export default MessageBoxIcon;
